/** Textos del giro tomado de la constancia ya guardada o capturado a mano. */

export const GIRO_VACIO = {
  giro_scian: "",
  giro_descripcion: "",
  origen_giro: "",
  guardado: false,
  tiene_constancia: false,
  actividades: [],
  giros_referencia: [],
  sugerencia: null,
  actividad_orden: null,
  actividad_descripcion: "",
  actividad_porcentaje: null,
  mensaje: "",
};

export function giroDesdeApi(data) {
  return {
    ...GIRO_VACIO,
    giro_scian: data?.giro_scian || "",
    giro_descripcion: data?.giro_descripcion || "",
    origen_giro: data?.origen_giro || "",
    guardado: Boolean(data?.guardado),
    tiene_constancia: Boolean(data?.tiene_constancia),
    actividades: Array.isArray(data?.actividades) ? data.actividades : [],
    giros_referencia: Array.isArray(data?.giros_referencia) ? data.giros_referencia : [],
    sugerencia: data?.sugerencia || null,
    actividad_orden: data?.actividad_orden ?? null,
    actividad_descripcion: data?.actividad_descripcion || "",
    actividad_porcentaje: data?.actividad_porcentaje ?? null,
    mensaje: data?.mensaje || "",
  };
}

export function claveActividad(act) {
  return `${act?.orden ?? ""}|${act?.descripcion || ""}`;
}

export function etiquetaOrigen(origen) {
  if (origen === "constancia" || origen === "manual") return `Origen: ${origen}`;
  return "Origen: sin definir";
}
